<template>
  <AppModal heading="Request Assistance" @close="$emit('close')">
    <div slot="content">
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <select
              class="form-input focus:text-opacity-100"
              v-model="formData.issue_title"
              name="Enquiry Type"
              :class="{'text-dark text-opacity-50': !formData.issue_title}"
              placeholder="Issue Title"
            >
              <option value disabled>Issue Title</option>
              <option value="Request Cancellation">
                Request Cancellation
              </option>
              <option value="Request Return">Request Return</option>
              <option value="Order issues">Order issues</option>
            </select>
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <input
              class="form-input"
              type="text"
              placeholder="Issue Description"
              name="Issue Description"
              v-model="formData.issue_description"
            >
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <ValidationProvider v-slot="{ errors }" rules="required">
            <textarea
              class="w-full border border-dark-b rounded-lg p-3 h-48"
              placeholder="Additional Notes"
              name="Additional Notes"
              v-model="formData.additional_notes"
            />
            <div class="input-error">{{ errors[0] }}</div>
          </ValidationProvider>
          <button :disabled="requested" class="new-app-btn bg-blue mt-1">Submit</button>
        </form>
      </ValidationObserver>
    </div>
  </AppModal>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'ServiceRequestModal',
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        issue_title: '',
        issue_description: '',
        additional_notes: ''
      },
      requested: false
    }
  },
  methods: {
    ...mapActions ([
      'openServiceRequest'
    ]),
    async onSubmit() {
      if(this.requested) return;
      this.requested = true;
      const response = await this.openServiceRequest({
        id: this.order.orderInformation.id,
        formData: this.formData
      })

      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message,
        duration: 7000
      })
      this.$emit('close')
    }
  }
}
</script>
